module.exports = __webpack_public_path__ + "static/media/8OLA4.956de525.jpg";